import avaleht from "./pages/en/avaleht.i18n";
import majutus from "./pages/en/majutus.i18n";
import yritused from "./pages/en/yritused.i18n";
import sadam from "./pages/en/sadam.i18n";
import karavan from "./pages/en/karavan.i18n";
import tegevused from "./pages/en/tegevused.i18n";
import kontakt from "./pages/en/kontakt.i18n";
import toitlustus from "./pages/en/toitlustus.i18n";
import projekt from "./pages/en/projekt.i18n";

import React from "react";

const yld = {
  "yld.hinnakiri": "Prices",
  "yld.kysipakkumist": "Contact us",
  "yld.kaardid.loelahemalt": "Learn more",
  "yld.navigatsioon.avaleht": "Homepage",
  "yld.navigatsioon.majutus": "Accomodation",
  "yld.navigatsioon.motell": "Motel",
  "yld.navigatsioon.ridaelamud": "Terraced houses",
  "yld.navigatsioon.saunamajad": "Saunas",
  "yld.navigatsioon.palkmajad": "Loghouses",
  "yld.navigatsioon.kampingud": "Camphouses",
  "yld.navigatsioon.yritused": "Events",
  "yld.navigatsioon.suvepaevad": "Holiday parties",
  "yld.navigatsioon.synnipaevad": "Birthdays",
  "yld.navigatsioon.pulmad": "Weddings",
  "yld.navigatsioon.seminarid": "Conferences",
  "yld.navigatsioon.toitlustus": "Catering",
  "yld.navigatsioon.sadam": "Harbour",
  "yld.navigatsioon.karavan": "Caravans & camping",
  "yld.navigatsioon.tegevused": "Activities",
  "yld.navigatsioon.windsurf": "Windsurf",
  "yld.navigatsioon.sup": "Supboarding",
  "yld.navigatsioon.pallimangud": "Ballsports",
  "yld.navigatsioon.discgolf": "DiscGolf",
  "yld.navigatsioon.piljard": "Bar & pool",
  "yld.navigatsioon.saunad": "Sauna",
  "yld.navigatsioon.paadirent": "Fishing & Boat rent",
  "yld.navigatsioon.jalgrattarent": "Bike rent",
  "yld.navigatsioon.jahindus": "Hunting",
  "yld.navigatsioon.koostoopartnerid": "Partnered activities",
  "yld.navigatsioon.galerii": "Gallery",
  "yld.navigatsioon.kontakt": "Contact",
  "yld.navigatsioon.covid": "COVID-19",
  "yld.keel": "Language",
  covid: () => (
    <>
      <h2 className="title is-2">Information about Covid-19</h2>
      <p>
        With the COVID-19 safety label, trusted to us by Visit Pärnu we confirm
        that we follow the requirements and instructions of the{" "}
        <a href="https://kriis.ee/en" target="_blank" rel="noopener noreferrer">
          Government and the Health Board of Estonia
        </a>{" "}
        established for our field of activity, we keep up to date with the
        information and help visitors to comply with the virus prevention rules
        on site.
      </p>
      <p>At our establishment you can be sure that:</p>
      <ul>
        <li>
          The visitor's code of conduct and information on the Covid-19 virus
          prevention activities implemented by us is available for all clients
        </li>
        <li>
          all employees are aware of the guidelines for preventing the spread of
          the virus and follow them in their daily work
        </li>
        <li>the indoor ventilation system is working properly</li>
        <li>
          there are enough disinfectants, they are available in places visible
          to everyone
        </li>
        <li>
          frequently touched surfaces are cleaned and disinfected regularly
        </li>
        <li>
          employees and guests are required to wear a mask or alternative
          personal protective equipment in accordance with applicable national
          regulations
        </li>
        <li>
          the possibility to maintain the necessary distance both with each
          other and with the service providers is ensured
        </li>
        <li>
          people with signs of illness are not allowed to be in public places or
          in the service area
        </li>
        <li>
          people who have come into contact with a client or employee with signs
          of illness are informed of the exposure without disclosing personal
          data
        </li>
        <li>
          we participate in COVID-19 prevention webinars organised by Enterprise
          Estonia.
        </li>
      </ul>
    </>
  ),
};

const translations = Object.assign(
  yld,
  avaleht,
  toitlustus,
  majutus,
  yritused,
  sadam,
  karavan,
  tegevused,
  kontakt,
  projekt
);

export default translations;
